const optimizelyTracking = {
  initialized: false,

  init: function() {
    if (!this.initialized) {
      if (window.optimizely) {
        this.initialized = true;
      } else {
        setTimeout(() => this.init(), 500);
      }
    }

    return this.initialized;
  },

  trackEvent: function(eventName, attributes) {
    if (!this.init()) {
      return false;
    }

    try {
      if (window.optimizely && window.optimizely.push) {
        if (attributes && Object.keys(attributes).length > 0) {
          window.optimizely.push({
            "type": "event",
            "eventName": eventName,
            "tags": attributes
          });
        } else {
          window.optimizely.push({
            "type": "event",
            "eventName": eventName
          });
        }

        return true;
      }

      return false;
    } catch (error) {
      console.error(`Optimizely error tracking event:`, error);
      return false;
    }
  },

  setUserAttributes: function() {
    if (!this.init()) return false;

    try {
      const attributes = {
        taken_practice_milestone: window.SOPHIA.takenPracticeMilestone(),
        has_practice_milestone_and_milestone: window.SOPHIA.courseHasPracticeMilestoneAndMilestone(),
        risk_prediction_score: window.SOPHIA.riskPredictionScore()
      };

      window.optimizely.push({
        "type": "user",
        "attributes": attributes
      });

      return true;
    } catch (error) {
      console.error('Error setting user attributes:', error);
      return false;
    }
  },

  pushToDataLayer: function(eventName, userId, attributes) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      userId: userId,
      attributes: attributes || {}
    });
  }
};

SOPHIA.optimizelyTracking = optimizelyTracking;

function isLoggedIn() {
  return document.cookie.split(';').some(function(c) {
    return c.trim().startsWith('logged_in=');
  });
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    if (isLoggedIn()) return;

    if (window.optimizely && window.SOPHIA && window.SOPHIA.loggedIn()) {
      SOPHIA.optimizelyTracking.setUserAttributes();

      window.SOPHIA.optimizelyData = {
        practiceMilestoneLink: window.SOPHIA.linkToPracticeMilestone()
      };


      window.optimizely.push({
        "type": "activate"
      });
    }
  }, 500);
});


export default optimizelyTracking;
